<template>
  <div v-lazyload class="image__wrapper">
    <!-- <ImageSpinner class="image__spinner"/> -->
    <img
      class="preload-img"
      :data-url="'pics/'+source"
      alt="..."
    >
  </div>
</template>

<script>

export default {
  props: {
    source: {
      type: String,
      required: true
    }
  }
}

</script>

<style scoped>

.preload-img {
  transition: opacity 1000ms ease;
  opacity: 0;
}

img {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  vertical-align: middle;

  -o-object-fit: cover;
  object-fit: cover;

  -o-object-position: 50% 50%;
  object-position: 50% 50%;
  border: 0px solid #fff;
  background-color: #e0e0e0;
}

</style>
